<template>
    <form :action="url" enctype="multipart/form-data" :id="'dropzone-' + _uid" class="dropzone">
        <div class="fallback">
            <input name="file" type="file" multiple />
        </div>
    </form>
</template>
<script>
    export default {

        props:{
            url: {
                type: String,
                required: true,
            },
            files: {
                type: Array,
                required: false,
                default: () => {
                    return []
                }
            },
            acceptedFiles:{
                type: String,
                required: false,
                default: ".doc,.docx,.pdf,.jpg,.jpeg,.png,.gif,.xls,.xlsx,.txt"
            },
            appends:{
                type: Object,
                required: false,
                default: () => {}
            }
        },

        data() {
            return {
                dropzone: null,
            }
        },

        mounted() {
            this.initializeDropbox();
            this.loadStoredFiles()
        },

        methods: {

            initializeDropbox() {
                Dropzone.autoDiscover = false;
                this.dropzone = new Dropzone(`#dropzone-${this._uid}`, {
                    url: this.url,
                    dictDefaultMessage: 'Drag or Click here to upload Files',
                    acceptedFiles: this.acceptedFiles,
                    headers: {
                        'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]').content
                    }
                });
                this.dropzone.on("success", (response, serverResponse) => {
                    this.$emit('success', serverResponse);
                });
                this.dropzone.on('sending', (file, xhr, formData) => {
                    for (var key in this.appends) {
                        formData.append(key, this.appends[key])
                    }
                });
                this.dropzone.on("error", (response, serverResponse) => {
                    var message = (typeof serverResponse == 'string') ? serverResponse : serverResponse.message;
                    Alert.error(message)
                    this.$emit('error', {response, serverResponse});
                });
            },

            loadStoredFiles(){
                this.files.forEach(file => {
                    this.dropzone.options.addedfile.call(this.dropzone, file);
                    this.dropzone.options.thumbnail.call(this.dropzone, file, file.full_path);
                })
            }
        }
    }
</script>
